import React from "react";
import { NumberInput } from "@jsq/ds/core";
import {
  createFieldPlaceholder,
  handleNumberInputWheel,
  validateNumericInput,
  VALIDATION_PATTERNS,
} from "./utils";
import type { FieldEditorProps } from "./types";

/**
 * Percentile Field Editor Component
 *
 * Specialized input component for percentile extension fields.
 * Provides percentage input with range validation (0-100).
 */
export const PercentileFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    // Validate input using the same pattern as the original NumericFieldEditor
    if (validateNumericInput(newValue, VALIDATION_PATTERNS.POSITIVE_DECIMAL)) {
      onChange(newValue);
    }
  };

  const handleSetValue = (newValue: string) => {
    // Validate input using the same pattern as the original NumericFieldEditor
    if (validateNumericInput(newValue, VALIDATION_PATTERNS.POSITIVE_DECIMAL)) {
      onChange(newValue);
    }
  };

  const placeholder = createFieldPlaceholder(field, "(0-100)");

  return (
    <NumberInput
      value={value}
      onChange={handleChange}
      onSetValue={handleSetValue}
      onWheel={handleNumberInputWheel}
      placeholder={placeholder}
      disabled={disabled}
      errorMessage={error || undefined}
      isFullWidth
      step={0.01}
      min={0}
      max={100}
      data-testid="percentile-field-editor"
    />
  );
};

export default PercentileFieldEditor;
